module.exports = __webpack_public_path__ + "img/blue-circle.30ce2654.svg";